export default "__VITE_ASSET__CV0Fj_NK__"